import Layout from './layout'

export default [
  // 品库编辑
  {
    path: '/pk-edit',
    component: Layout,
    alwaysShow: true,
    meta: { groupTitle: '品库后台', title: '品库编辑', icon: 'edit_admin', roles: ['admin'] },
    children: [
      {
        path: 'await-release',
        name: 'pkEditAwaitRelease',
        component: () => import(/* webpackChunkName: "pkEditAwaitRelease" */ '@v/pkEdit/awaitRelease'),
        meta: { title: '待发布商品' },
      },
      {
        path: 'alreadyRelease',
        name: 'pkEditAlreadyRelease',
        component: () => import(/* webpackChunkName: "pkEditAlreadyRelease" */ '@v/pkEdit/alreadyRelease'),
        meta: { title: '已发布商品' },
      },
      {
        path: 'edit',
        name: 'pkEdit',
        hidden: true,
        component: () => import(/* webpackChunkName: "pkEdit" */ '@v/pkEdit/edit'),
        meta: { title: '编辑商品' },
      },
      {
        path: 'bd-manage',
        name: 'BdManage',
        component: () => import(/* webpackChunkName: "BdManage" */ '@v/pkEdit/bdManage'),
        meta: { title: '榜单管理' },
      },
      {
        path: 'bd-add',
        name: 'BdAdd',
        hidden: true,
        component: () => import(/* webpackChunkName: "bdAdd" */ '@v/pkEdit/bdAdd'),
        meta: { title: '添加商品到榜单' },
      },
      {
        path: 'blacklist',
        name: 'Blacklist',
        component: () => import(/* webpackChunkName: "Blacklist" */ '@v/pkEdit/blacklist'),
        meta: { title: '黑名单管理' },
      },
      {
        path: 'banner',
        name: 'Cmsbanner',
        component: () => import(/* webpackChunkName: "Cmsbanner" */ '@v/cmsbanner'),
        meta: { title: '轮播图管理' },
      },
    ],
  },
]
